<script>
    import Button from "@smui/button";
    import LinearProgress from "@smui/linear-progress/LinearProgress.svelte";

    import { onMount } from "svelte";

    import title from "../../components/title";
    import { post } from "../../http";
    import { getObject } from "../../session";
    import { navigate } from "svelte-routing";
    import snackbar from "../../components/snackbar";

    export let location;
    let loading = false;
    let order = {};
    let orderID;
    let waNumber = "";
    let waText = "";
    let showPickup = false;
    let buttons = [];

    function scrollBottom() {
        setTimeout(
            () =>
                window.scrollTo({
                    left: 0,
                    top: window.document.body.scrollHeight,
                    behavior: "smooth",
                }),
            100
        );
    }
    function next() {
        loading = true;
        let order = getObject("order");

        delete order.delivery_type_description;

        post("/api/create_order", order)
            .then((resp) => {
                if (resp.status == 0) {
                    orderID = resp.data.order_id;
                    waNumber = resp.data.wa_bot;
                    waText = resp.data.wa_keyword;

                    sessionStorage.setItem("orderID", orderID);
                    sessionStorage.setItem("waNumber", waNumber);
                    sessionStorage.setItem("waText", waText);

                    buttons = [];
                    buttons.push(resp.data["button"]);
                    sessionStorage.setItem("buttons", JSON.stringify(buttons));
                    snackbar.open("Order berhasil dengan ID " + orderID);
                } else {
                    snackbar.open(resp.message);
                }
            })
            .finally(() => (loading = false));
    }

    function back() {
        if (waNumber == "") {
            waNumber = sessionStorage.getItem("waNumber");
            waText = sessionStorage.getItem("waText");
        }
        window.open("https://wa.me/" + waNumber + "?text=" + waText);
    }
    function newOrder() {
        sessionStorage.removeItem("orderID");
        sessionStorage.removeItem("buttons");
        sessionStorage.removeItem("order");
        navigate("/origin");
    }

    function click(buttonID) {
        switch (buttonID) {
            case "pickup":
                navigate("/pickup/time");
                break;
        }
    }

    onMount(() => {
        order = getObject("order");
        orderID = sessionStorage.getItem("orderID");
        title.set("Review Order");

        const b = sessionStorage.getItem("buttons");
        if (b != null) buttons = JSON.parse(b);
    });
</script>

<style lang="scss">
    .content {
        font-size: 0.95em;
        & .label {
            margin-bottom: 4px;
            font-size: 1.1em;
            font-weight: 500;
            &:not(:first-of-type) {
                margin-top: 16px;
            }
        }
        & .button {
            margin-top: 16px;
            text-align: right;
        }

        & .summary {
            padding-top: 16px;
        }
    }
    .loading.hide {
        visibility: hidden;
        opacity: 0;
    }
</style>

<div class="loading" class:hide={!loading}>
    <LinearProgress indeterminate />
</div>

<div class="content nogap">
    <div class="label">Pengirim</div>
    <div>{order.shipper_name} ({order.shipper_phone})</div>
    <div>{order.shipper_address}</div>
    <div>
        {order.shipper_district},
        {order.shipper_city},
        {order.shipper_province}
        {order.shipper_zipcode}
    </div>
    <div class="label">Tujuan</div>
    <div>{order.recipient_name} ({order.recipient_phone})</div>
    <div>{order.recipient_address}</div>
    <div>
        {order.recipient_district},
        {order.recipient_city},
        {order.recipient_province}
        {order.recipient_zipcode}
    </div>
    <div class="label">Rincian Barang</div>
    <div>{order.parcel_category} {order.parcel_weight}Kg</div>
    {#if order.parcel_value > 0}
        <div>Harga: Rp. {order.parcel_value}</div>
    {/if}
    {#if order.notes != ''}
        <div>Catatan: {order.notes}</div>
    {/if}
    <div class="label">Jenis Pengiriman</div>
    <div>{order.delivery_type} ({order.delivery_type_description})</div>
    <div class="label">Tarif</div>
    <div class="row">
        <div>{order.delivery_type}</div>
        <div class="fill" />
        <div>Rp. {order.tarif}</div>
    </div>
    <div class="row">
        <div>Asuransi</div>
        <div class="fill" />
        <div>Rp. {order.insurance}</div>
    </div>
    <div class="row">
        <div>Total</div>
        <div class="fill" />
        <div>Rp. {+order.tarif + +order.insurance}</div>
    </div>
    {#if orderID == null}
        <div class="button">
            <Button
                on:click={next}
                variant="unelevated"
                class="rounded"
                disabled={loading}>
                Lanjutkan
            </Button>
        </div>
    {:else}
        <div class="summary">
            <div>Order berhasil dengan ID: {orderID}</div>
            <div class="text-right">
                {#each buttons as button}
                    <div>
                        <Button
                            variant="outlined"
                            on:click={() => click(button.id)}>
                            {button.text}
                        </Button>
                    </div>
                {/each}
                <div>
                    <Button variant="outlined" on:click={newOrder}>
                        Order baru
                    </Button>
                </div>
                <div>
                    <Button variant="outlined" on:click={back}>
                        Kembali ke Whatsapp
                    </Button>
                </div>
            </div>
        </div>
    {/if}
</div>
